import React, { useContext } from "react"
import { List } from "@mui/material"
import { UserContext } from "src/providers"
import NavbarEntry, { NavbarDivider } from "./NavbarEntry"
import { getIcon, getPath, TabletType } from "src/models/company"

interface CustomEntry {
  iconPath: string
  label: string
  path: string
  name?: string
  show?: boolean
}

interface TabletEntriesProps {
  open: boolean
  type: TabletType
  additionalEntries?: CustomEntry[]
  onNavigate?: () => void
}

export const TabletEntries = ({ open, type, additionalEntries = [], onNavigate }: TabletEntriesProps) => {
  const { tablets } = useContext(UserContext)
  const tabletOfType = tablets
    .filter((t) => ["ACTIVE"].includes(t.status))
    .filter((t) => t.type === type)

  const visibleAdditionalEntries = additionalEntries.filter(entry => entry.show !== false)
  
  const show = tabletOfType.length > 0 || visibleAdditionalEntries.length > 0

  return (
    <>
      {show && <NavbarDivider open={open} />}
      {show && (
        <List>
          {tabletOfType.map((t) => (
            <NavbarEntry
              open={open}
              key={t.id}
              iconPath={getIcon(t)}
              label={t.title}
              path={getPath(t)}
              data-testid={`menu-${t.name || t.title.replaceAll(" ", "-").toLowerCase()}-button`}
              onNavigate={onNavigate}
            />
          ))}
          {visibleAdditionalEntries.map((entry, index) => (
            <NavbarEntry
              open={open}
              key={`additional-${index}`}
              iconPath={entry.iconPath}
              label={entry.label}
              path={entry.path}
              data-testid={`menu-${entry.name || entry.label.replaceAll(" ", "-").toLowerCase()}-button`}
              onNavigate={onNavigate}
            />
          ))}
        </List>
      )}
    </>
  )
}
